var _rect, _rect2, _path, _path2, _rect3, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgScheduleSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.002,
    height: 14,
    viewBox: "0 0 14.002 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 0.779,
    height: 1.928,
    transform: "translate(2.856)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 0.779,
    height: 1.928,
    transform: "translate(8.184)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.878,32.609a3.263,3.263,0,1,0,3.27,3.263A3.27,3.27,0,0,0,12.878,32.609Zm0,5.748a2.485,2.485,0,1,1,2.49-2.486A2.49,2.49,0,0,1,12.878,38.357Z",
    transform: "translate(-2.145 -25.135)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.083,34.087H13.3V36.2a.389.389,0,0,0,.115.275L14.846,37.9l.551-.55-1.314-1.311Z",
    transform: "translate(-2.961 -25.464)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.732,
    height: 0.778,
    transform: "translate(4.005 0.575)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.809,26.242H10.95v3.494h.779v-6H9.46v.778h1.49v.947H.809v-.947h1.6v-.778H.03V34.29H6.608v-.778H.809Z",
    transform: "translate(-0.03 -23.164)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(2.204 3.993)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(2.204 5.989)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(2.204 7.985)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(4.204 3.993)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(4.204 5.989)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(4.204 7.985)"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(6.204 3.993)"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(6.204 5.989)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 0.998,
    transform: "translate(8.204 3.993)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgScheduleSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/schedule-small.8f1069fa7d94666abb7e3d64d1fee8d9.svg";